import { BasicModel } from './BasicModel';

export class StateModel extends BasicModel {
  constructor({ id, name }: { id: string; name: string }) {
    super({ id, name });
  }
}
